import { useTertiaryListFormState } from "components/ReleaseForm/Hooks";
import { Comment, SecondaryFormNames, TertiaryFormNames } from "types";

export const useContributorFormState = (trackId: string, recordId?: string) => {
  const isSameComment = (tertiaryFormId: string, fieldName: string) => (comment: Comment) =>
    comment.releaseContributorId === tertiaryFormId && comment.fieldName === fieldName;

  return useTertiaryListFormState()({
    secondaryFormName: SecondaryFormNames.ReleaseTracks,
    secondaryFormId: trackId,
    tertiaryFormName: TertiaryFormNames.ReleaseContributors,
    tertiaryFormId: recordId ?? "",
    filterCommentsCb: ({ releaseContributorId }) => releaseContributorId === recordId,
    updateCommentCb: (tertiaryFormId, c) => (comment) =>
      isSameComment(tertiaryFormId, c.fieldName)(comment) ? { ...comment, ...c } : comment,
    deleteCommentCb: (tertiaryFormId, fieldName) => (comment) => !isSameComment(tertiaryFormId, fieldName)(comment),
  });
};
